import React from 'react';
import { JOB_PAGE_STATES } from '@model/Job/_constants/Job.constants';

export const PageStateContext = React.createContext(JOB_PAGE_STATES.TO_DO);
export const PageStateProvider = PageStateContext.Provider;
